import api from "../libs/api";

export default {
    searchUsers: (query, page = 1, perPage = 10) => {
    return new Promise((resolve, reject) => {
        api()
            .get("/users-search", {
                params: {
                    query: query,
                    page: page,
                    per_page: perPage,
                },
            })
            .then(({ status, data }) => {
                if (status === 200) {
                    resolve(data);
                } else {
                    reject(new Error(`Failed with status: ${status}`));
                }
            })
            .catch((error) => reject(error));
    });
},
};